import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      minHeight: '100vh',
    },
  },
  { name: 'Layout' }
);
